import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PurchaseSuccess from './PurchaseSuccess';

class PurchaseAlbumCheckoutSuccess extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    purchasedUrl: PropTypes.string,
  };

  render() {
    const { album, loading, purchasedUrl } = this.props;

    if (loading) {
      return null;
    }

    return (
      <PurchaseSuccess purchasedUrl={purchasedUrl} stringContext={album} />
    );
  }
}

export default PurchaseAlbumCheckoutSuccess;
